(() => {
  const drawer = document.querySelector('[data-account-drawer]');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  let returnFocus;
  const routeKey = value => {
    try { const url = new URL(value, window.location.href); return url.origin + url.pathname.replace(/\/$/, ''); }
    catch { return ''; }
  };
  const accountRoutes = new Set([routeKey(drawer.dataset.loginUrl), routeKey(drawer.dataset.accountUrl)]);
  accountRoutes.delete('');
  const close = () => { if (drawer.open) drawer.close(); };
  const open = trigger => {
    if (drawer.open) return;
    returnFocus = trigger;
    const newsletter = document.querySelector('[data-newsletter-dialog][open]');
    newsletter?.querySelector('[data-newsletter-close]')?.click();
    document.querySelectorAll('.lh-nav-disclosure[open]').forEach(item => { item.open = false; });
    drawer.showModal();
    document.documentElement.setAttribute('data-lh-account-open', '');
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || drawer.contains(link) || link.hasAttribute('data-account-bypass') || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (!accountRoutes.has(routeKey(link.href))) return;
    event.preventDefault();
    open(link);
  });
  drawer.querySelector('[data-account-close]')?.addEventListener('click', close);
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  drawer.addEventListener('close', () => {
    document.documentElement.removeAttribute('data-lh-account-open');
    if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
  });
})();




